import {http, param} from '../../utils/http'
import conf from '../../config'
export const API_ROOT = `${conf.API_URL}`
import fileDownload from 'js-file-download'

const transactionBillingService = {
    findBillingSummary(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null },
            {query: 'fromDate', val: payload.billing_from_date},
            { query: 'toDate', val: payload.billing_to_date },
        ]
        return http.get(`${API_ROOT}/notisphere/transactionBilling${param(arr)}`).then(resp => {
            return resp
        })
    },
    getBillingDetailsById(organizationId, fromDate, toDate) {
        var arr = [
            {query: 'fromDate', val: fromDate},
            { query: 'toDate', val: toDate },
        ]
        return http.get(`${API_ROOT}/notisphere/transactionBilling/${organizationId}/billingDetails${param(arr)}`).then(resp => {
            return resp
        })
    },
    downloadTransactionDetailsReport(organizationId, fromDate, toDate) {
        var arr = [
            {query: 'fromDate', val: fromDate},
            { query: 'toDate', val: toDate },
        ]
        return http.get(`${API_ROOT}/notisphere/transactionBilling/${organizationId}/downloadxlsx${param(arr)}`,{ responseType: 'blob' }).then(resp => {
            var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Transaction Details Report ' + DateTime +'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        })
    },
}

export default transactionBillingService
